import { Map as map } from 'immutable';
const C = require("../constants");

function ModalExpenseDialogReducer(state = map(), action) {
    switch (action.type) {
        case C.EXPENSE_MODAL:
            return action.modal;
        default:
            return state;
    }
}

export default ModalExpenseDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalExpenseDialogReducer.js